import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import Intro from './components/Intro';
import ProductsGrid from './components/ProductsGrid';
import ExploreFurther from './components/ExploreFurther';
import BottomCTA from './components/BottomCTA';
import CertificationBanner from '@/components/feature/CertificationBanner';
import { collectionPageJsonLd } from '@/components/feature/ProductJsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://popprotents.com';

const jsonLd = collectionPageJsonLd({
  name: 'Stretch Tent Products — Rentals, Custom & Accessories | Pop Pro Tents',
  description: 'Explore our full range of premium stretch tents including standard rentals, custom-built tents, custom printed skins, bespoke decor, and fabric options. Austin-based with Texas-wide and nationwide delivery.',
  url: `${siteUrl}/products`,
  items: [
    { name: 'Standard Stretch Tents', url: `${siteUrl}/products/standard-stretch-tents` },
    { name: 'Custom Stretch Tents', url: `${siteUrl}/products/custom-stretch-tents` },
    { name: 'Custom Printed Skins', url: `${siteUrl}/products/custom-printed-skins` },
    { name: 'Bespoke Decor', url: `${siteUrl}/products/bespoke-decor` },
    { name: 'Fabric & Colours', url: `${siteUrl}/products/fabric-and-colours` },
  ],
});

export default function ProductsPage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <CertificationBanner />
        <ProductsGrid />
        <ExploreFurther />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  );
}